import React, { useContext, useEffect, useMemo, useState } from "react";
import { LineChart, Serie, SpotItem } from "react-charts";
import { cloneDate, formatDate, monthName, normalizeDateItems, parseDate } from "simple-utils/dist/date-utils";
import { DailyReport, FullReportEntry } from "../../models/FullReportEntry";
import { formatMoney } from "../../utils/money-utils";
import { AccountContext, useShowPrevious, useTableMode } from "../AccountContext";
import { buildSeries } from "./buildSeries";
import { AdDetailContext } from "../../ads-detail-page/DetailStore";

var beginDate = new Date();

function useUpdateBeginDate(period:string){
    useEffect(function(){
        if(!period){
            beginDate = new Date();
            beginDate.setDate(1);
        }
        else    
            beginDate = parseDate(period + "-01");
    }, [period]);
}

function xLabel(n:number){
    var d = cloneDate(beginDate);
    d.setDate(n);
    return d.getDate() + "/" + monthName(d, true);
}

function buildCostSeries(account:FullReportEntry):Serie[]{
    return buildSeries(account.dailyReports, account.past?.dailyReports, "cost",  account.overrun > 1 ? "color4" : "color1");
}

function createTooltipDate(e: SpotItem[]){
    if(e == null) return null;
    if(e.length == 0) return null;
    return <>
        <div className="mb-1">        
            <b>Investimento</b><br />
            {xLabel(e[0].item.realX || e[0].item.x)}
        </div>
        {
           e.map( (i, n) => <div className={i.serie.style} key={n}>{i.serie.label}: <b className="text-color">{formatMoney(i.item.y)}</b></div>) 
        }
    </>
}


export function CostChart({account, toolTipContainer = '.detail-div'}:{account: FullReportEntry, toolTipContainer?:string}){
    const {period} = useContext(AccountContext)
    const {state} = useContext(AdDetailContext)
    useUpdateBeginDate(period || state.period);

    const showPrevious = useShowPrevious();
    const tableMode = useTableMode();
    const series = useMemo(()=> buildCostSeries(account), [account])
    return <LineChart key={account.metaId + "-" + showPrevious} data={series} hintScales={[{value: account.dayBudget, style: "color2"}]} 
      xLabelFunction={xLabel} yLabelFunction={(n) => formatMoney(n)} createTooltip={createTooltipDate} tooltipContainer={tableMode ? undefined : toolTipContainer}
      hidden={showPrevious ? null : ["Mês Passado"]}
      height={150} hideLegend={true} />
}

export function SummaryCostChart({report, past}:{report: DailyReport[], past: DailyReport[]}){
    const {period} = useContext(AccountContext)
    useUpdateBeginDate(period);

    const series = useMemo(()=> buildSeries(report, past, "cost"), [report] )
    const [key, setKey] = useState(0);
    useEffect(() => setKey(key + 1), [series]);

    return <LineChart key={key} data={series}  yLabelFunction={(n) => formatMoney(n)}
      xLabelFunction={xLabel} createTooltip={createTooltipDate} tooltipContainer={'.detail-div'}
      hidden={["Mês Passado"]}
      height={150} hideLegend={true} />
}